import { stacksArraySchema } from '@src/components/Home/Config/Stacks/validation/stackSchema';
import { UseTemplateValidationResult } from '@src/types/hooks';
import { getValidationTypeGuards } from '@src/utils/validationTypeGuards';
import useFileValidation from './useFileValidation';

export default function useStackValidation(): UseTemplateValidationResult {
  const {
    createStringPropertyTypeGuard,
    createArrayPropertyTypeGuard,
    isObjectWithProperty,
  } = getValidationTypeGuards();

  const isStackWithName = createStringPropertyTypeGuard('name');
  const isControlModeWithName = createStringPropertyTypeGuard('name');
  const isSectionWithLabel = createStringPropertyTypeGuard('uiLabel');
  const isFieldWithLabel = createStringPropertyTypeGuard('uiLabel');
  const isObjectWithControlModes = createArrayPropertyTypeGuard('controlModes');
  const isObjectWithSections = createArrayPropertyTypeGuard('sections');
  const isObjectWithFields = createArrayPropertyTypeGuard('fields');

  return useFileValidation({
    schema: stacksArraySchema,
    entityName: 'Stack',
    arrayProcessors: {
      '': (currentObject, index) => {
        if (Array.isArray(currentObject)) {
          return {
            humanPart: isStackWithName(currentObject[index])
              ? `Stack "${currentObject[index].name}"`
              : `Stack [${index}]`,
            nextObject: currentObject[index] as
              | Record<string, unknown>
              | undefined,
          };
        }
        return {
          humanPart: `Stack [${index}]`,
          nextObject: undefined,
        };
      },
      controlModes: (currentObject, index) => {
        if (isObjectWithControlModes(currentObject)) {
          const item = currentObject.controlModes[index];
          return {
            humanPart: isControlModeWithName(item)
              ? `Control Mode "${item.name}"`
              : `Control Mode [${index}]`,
            nextObject: item as Record<string, unknown> | undefined,
          };
        }
        return {
          humanPart: `controlModes[${index}]`,
          nextObject: undefined,
        };
      },
      sections: (currentObject, index) => {
        if (isObjectWithSections(currentObject)) {
          const item = currentObject.sections[index];
          return {
            humanPart: isSectionWithLabel(item)
              ? `Section "${item.uiLabel}"`
              : `Section [${index}]`,
            nextObject: item as Record<string, unknown> | undefined,
          };
        }
        return {
          humanPart: `sections[${index}]`,
          nextObject: undefined,
        };
      },
      fields: (currentObject, index) => {
        if (isObjectWithFields(currentObject)) {
          const item = currentObject.fields[index];
          return {
            humanPart: isFieldWithLabel(item)
              ? `Field "${item.uiLabel}"`
              : `Field [${index}]`,
            nextObject: item as Record<string, unknown> | undefined,
          };
        }
        return {
          humanPart: `fields[${index}]`,
          nextObject: undefined,
        };
      },
    },
    typeGuards: {
      createStringPropertyTypeGuard,
      createArrayPropertyTypeGuard,
      isObjectWithProperty,
    },
  });
}
